import { Grid, Tooltip,IconButton, Chip, Typography,Divider} from "@material-ui/core";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {makeStyles } from '@material-ui/core/styles';
import {getHeadingCount} from '../../utility';
import Mark from 'mark.js';


const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: theme.palette.common.white,
    },
    tooltip: {
      backgroundColor: theme.palette.primary.main,
    },
  }));

  
function TopicDetail(props){
    let GetHeadingObject = () => (
        (props.topic.header_usage).map((headings) => (
                <p>{headings.description}</p>
        )));

    setTimeout(()=> {
        const markInstance = new Mark(document.querySelectorAll(".topicMarkDown"));
        markInstance.mark(props.topic.name,[,{acrossElements:true}]);
    },1000);

    return (
        <Grid style={{minWidth:'20rem',maxWidth:'30rem',overflowX:'hidden'}}>
            <style>{"\
                mark{\
                    background: transparent;\
                    color: black;\
                    font-weight: bold;\
                }\
            "}</style>
            <Grid container xs="12" direction="row" justify="flex-start" alignItems="baseline">
                <Grid item xs="12" style={{padding:'1rem,1rem'}}>
                    <Tooltip title="Back" arrow classes={useStylesBootstrap()} style={{float:'left'}}>
                        <IconButton aria-label="Back" onClick={() => props.close()}>
                            <ArrowForwardIcon  color="primary" />
                        </IconButton>
                    </Tooltip> 
                    <Typography align="center" variant="subtitle2" style={{color:'#3e4b5b', fontWeight:'bold',margin:'0.5rem'}}>Example of <Typography display='inline' variant="subtitle1" style={{fontStyle:'italic',fontWeight:'bold'}}>{props.topic.name}</Typography>{(props.topic.similar_keywords.length > 0) ? <Typography display="block" variant="caption" style={{color:'grey',fontWeight:'500'}}>Similar: {props.topic.similar_keywords.toString()}</Typography> : null}</Typography>
                </Grid>
            </Grid>
            <Divider />
            <Grid container justify="space-between" alignItems="baseline" style={{margin:'0.5rem 0.5rem'}}>
                <Grid item xs="4">
                    <Typography align="center" variant="caption" display="block">Relevance</Typography>
                    <Typography align="center" variant="subtitle2" display="block" style={{color:'#3e4b5b',fontStyle:'italic',fontWeight:'bold'}}>{Math.round(parseFloat(props.topic.relevance))}%</Typography>
                </Grid>
                <Grid item xs="4">
                    <Typography align="center" variant="caption" display="block">Typical Usage</Typography>
                    <Typography align="center" variant="subtitle2" display="block" style={{color:'#3e4b5b',fontStyle:'italic',fontWeight:'bold'}}>{parseInt((props.topic.count.reduce((a, b) => a + b, 0))/(props.topic.count.length))} Uses</Typography>
                </Grid>
                <Grid item xs="4">
                    <Typography align="center" variant="caption" display="block">Current Usage</Typography>
                    <Typography align="center" variant="subtitle2" display="block" style={{color:'#3e4b5b',fontStyle:'italic',fontWeight:'bold'}}>{(props.topic.covered) ? `${props.topic.num_occurences_in_content} Use${props.topic.num_occurences_in_content > 1 ? 's' : ''}` : 'Not Used'}</Typography>
                </Grid>
            </Grid>
            <Divider />
            { getHeadingCount(props.topic) > 0 && <Grid container xs="11" direction="row" justify="flex-start" alignItems="baseline" style={{margin:'0.5rem 0.5rem'}}>
                <Grid item xs="12">
                    <Typography variant="h6" style={{color:'#3f4b5b', fontWeight:'bold',marginTop:'0.5rem'}}>Used in {getHeadingCount(props.topic)} Headings</Typography>
                </Grid>
                <Divider />
                {props.topic.header_usage.map((heading) => {
                    return (
                        <Grid item xs="12" style={{margin:'0.5rem 0.5rem'}}>
                            <Typography style={{color:'#3e4b5b', fontWeight:'bold',marginTop:'0.5rem'}}>{heading.title.substring(0, 55) + "..."}</Typography>
                            <img class="topic-detail-outline-icon" src={`https://www.google.com/s2/favicons?domain_url=${heading.url}`} style={{verticalAlign:'middle',marginRight:'0.2rem'}}></img>
                            <a target="_blank" href={heading.url}>{(heading.url).split('/')[0] + '//' + (heading.url).split('/')[2]}</a>
                            <Grid style={{margin:'1rem 1rem'}} className="topicMarkDown">
                            {(heading.sentences).map((sentence) =>
                                <li onCopy={(e)=>{navigator.clipboard.writeText(e.target.innerText)}}>{sentence}</li>
                                )}
                            </Grid>
                            <Divider />
                        </Grid>
                    )
                })}
            </Grid>}
            {Array.isArray(props.topic.summary) && <Grid container xs="12" direction="row" justify="flex-start" alignItems="baseline" style={{margin:'0.5rem 0.5rem'}}>
                <Grid item xs="12">
                    <Typography variant="h6" style={{color:'#3e4b5b', fontWeight:'bold',marginTop:'0.5rem'}}>Used in {props.topic.summary.length} Sources</Typography>
                </Grid>
                <Divider />
                {props.topic.summary.map((summary) => {
                    return (
                        <Grid item xs="12" style={{margin:'0.5rem 0.5rem'}}>
                            <Typography style={{color:'#3e4b5b', fontWeight:'bold',marginTop:'0.5rem'}}>{summary.title.substring(0, 55) + "..."}</Typography>
                            <img class="topic-detail-outline-icon" src={`https://www.google.com/s2/favicons?domain_url=${summary.url}`} style={{verticalAlign:'middle',marginRight:'0.2rem'}}></img>
                            <a target="_blank" href={summary.url}>{(summary.url).split('/')[0] + '//' + (summary.url).split('/')[2]}</a>
                            <Grid style={{margin:'1rem 1rem'}} className="topicMarkDown">
                            {(summary.sentences).map((sentence) =>
                                <li onCopy={(e)=>{navigator.clipboard.writeText(e.target.innerText)}}>{sentence}</li>
                                )}
                            </Grid>
                            <Divider />
                        </Grid>
                    )
                })}
            </Grid>}
        </Grid>
    );
}

export default TopicDetail